// @flow

import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Typography, Link } from '@material-ui/core/';
import PropTypes from 'prop-types';
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';

import './style.css';
type Props = {
    onBreadcumClick?: Function,
    onBreadCumLookupclick?:Function,
    onBreadCumAuthclick?:Function,
    onBreadCumListsclick?:Function,
    title:string
    
};

function BreadCrumb(props:Props) {
    const { onBreadcumClick,title } = props;
    return (
        <>
            <Breadcrumbs
                separator={<NavigateNextIcon fontSize="small" />}
                aria-label="breadcrumb"
            >
                <Link
                    component={RouterLink}
                    to={{
                        pathname: '/',
                        search: null
                    }}
                >
                    home
                </Link>
                <Link href="/docs">Documents</Link>
                <Link
                    component={RouterLink}
                    to={{
                        pathname: '/docs',
                        search: null,
                        state: { page: 'version4-createbinder' }
                    }}
                    onClick={onBreadcumClick}
                >
                    Action Methods
                </Link>
                <Typography color="textPrimary">{title}</Typography>
            </Breadcrumbs>
        </>
    );
}
BreadCrumb.propTypes = {
    onBreadcumClick: PropTypes.func,
    title: PropTypes.string.isRequired
};
export default BreadCrumb;



function LookupBreadCrumb(props:Props) {
    const { onBreadCumLookupclick,title } = props;
    return (
        <>
            <Breadcrumbs
                separator={<NavigateNextIcon fontSize="small" />}
                aria-label="breadcrumb"
            >
                <Link
                    component={RouterLink}
                    to={{
                        pathname: '/',
                        search: null
                    }}
                >
                    home
                </Link>
                <Link href="/docs">Documents</Link>
                <Link
                    component={RouterLink}
                    to={{
                        pathname: '/docs',
                        search: null,
                        state: { page: 'version4-taxsoftware' }
                    }}
                    onClick={onBreadCumLookupclick}
                >
                    Lookup Methods
                </Link>
                <Typography color="textPrimary">{title}</Typography>
            </Breadcrumbs>
        </>
    );
}
LookupBreadCrumb.propTypes = {
    onBreadCumLookupclick: PropTypes.func,
    title:PropTypes.string.isRequired
};

export { LookupBreadCrumb };

function ListsBreadCrumb(props:Props) {
    const { onBreadCumListsclick,title } = props;
    return (
        <>
            <Breadcrumbs
                separator={<NavigateNextIcon fontSize="small" />}
                aria-label="breadcrumb"
            >
                <Link
                    component={RouterLink}
                    to={{
                        pathname: '/',
                        search: null
                    }}
                >
                    home
                </Link>
                <Link href="/docs">Documents</Link>
                <Link
                    component={RouterLink}
                    to={{
                        pathname: '/docs',
                        search: null,
                        state: { page: 'version4-unclearednotes' }
                    }}
                    onClick={onBreadCumListsclick}
                >
                    Lists
                </Link>
                <Typography color="textPrimary">{title}</Typography>
            </Breadcrumbs>
        </>
    );
}
ListsBreadCrumb.propTypes = {
    onBreadCumListsclick: PropTypes.func,
    title: PropTypes.string.isRequired
};
export  {ListsBreadCrumb};


function Authentication(props:Props) {
    const { onBreadCumAuthclick,title } = props;
    return (
        <>
            <Breadcrumbs
                separator={<NavigateNextIcon fontSize="small" />}
                aria-label="breadcrumb"
            >
                <Link
                    component={RouterLink}
                    to={{
                        pathname: '/',
                        search: null
                    }}
                >
                    home
                </Link>
                <Link href="/docs">Documents</Link>
                <Link
                    component={RouterLink}
                    to={{
                        pathname: '/docs',
                        search: null,
                        state: { page: 'version4-gettoken' }
                    }}
                    onClick={onBreadCumAuthclick}
                >
                    Authentication
                </Link>
                <Typography color="textPrimary">{title}</Typography>
            </Breadcrumbs>
        </>
    );
}
Authentication.propTypes = {
    onBreadCumLookupclick: PropTypes.func,
    title:PropTypes.string.isRequired
};
export { Authentication };